import Vue from 'vue';

import Registration from './patient/Registration';

new Vue({
    components: {
        Registration
    },

    data() {
        return {
            active: 'visit',
        };
    },

    methods: {
        isActive(name) {
            return name === this.active;
        },

        swap(name) {
            this.active = name;
        }
    }
}).$mount('#main');
